module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "value": _vm.current
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Backup",
      "name": "backup"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Setting",
      "name": "setting"
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('save-' + _vm.current, {
    tag: "component"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4308acbe"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/save/Save.vue
// module id = 161
// module chunks = 1